module.exports = __webpack_public_path__ + "img/admin-ability-1.d1ce5772.png";